import React, { FC } from 'react';
import { toOpaqueHexForColorInput } from '../../../tools/chromaticPresets';
import type { ChromaticSchemeResultDisplay } from '../../../tools/chromaticResultLabel';
import './index.scss';

interface ChromaticSchemeResultValueProps {
  display: ChromaticSchemeResultDisplay;
}

// Renders one color swatch with its hex label in parentheses for result screens.
const ChromaticColorSwatch: FC<{ color: string }> = ({ color }) => {
  const hexLabel = (toOpaqueHexForColorInput(color) ?? color.trim()).toUpperCase();
  const swatchColor = toOpaqueHexForColorInput(color) ?? color.trim();

  return (
    <span className="chromatic-scheme-result-value__pair">
      <span
        className="chromatic-scheme-result-value__swatch"
        style={{ backgroundColor: swatchColor }}
        aria-hidden="true"
      />
      <span className="chromatic-scheme-result-value__hex">({hexLabel})</span>
    </span>
  );
};

// Renders chromatic scheme summary with color swatches and hex values for read-only result fields.
export const ChromaticSchemeResultValue: FC<ChromaticSchemeResultValueProps> = ({ display }) => {
  const { prefix, primary, secondary } = display;
  const hasColors = Boolean(primary && secondary);

  return (
    <span className="chromatic-scheme-result-value">
      {prefix ? <span className="chromatic-scheme-result-value__prefix">{prefix}</span> : null}
      {prefix && hasColors ? <span className="chromatic-scheme-result-value__sep">: </span> : null}
      {hasColors ? (
        <span className="chromatic-scheme-result-value__colors">
          <ChromaticColorSwatch color={primary} />
          <span className="chromatic-scheme-result-value__divider"> / </span>
          <ChromaticColorSwatch color={secondary} />
        </span>
      ) : null}
    </span>
  );
};

export default ChromaticSchemeResultValue;
